// //  CreateBatchTests.js
// //
// //  Updated 2/2.
// //
// //  Abstract: Create batch new tests functional component. CRUD Firestore and Firebase.

// //	React
// import React, { useEffect, useState } from 'react';

// // Components

// //	Material-ui components
// import { CircularProgress, Button, Grid, TextField, makeStyles } from '@material-ui/core';

// //	CSS Styles
// const useStyles = makeStyles((theme) => ({

// }));

// export default function CreateBatchTests(props) {

//     //  CSS styles
//     const classes = useStyles();

//     const { isButtonLoading, patientId, testId, patchIdsArray, plannedTestStartDate, onCreateTestSubmit, errors, onPatientIdChange, onTestIdChange, onPatchIdsArrayChange, onPlannedTestStartDateChange, onErrorsChange } = props;

//     return (
//         <>
//             <Grid container spacing={5} direction="column">
//                 <Grid item>
//                     To batch create tests, download the below CSV template and upload a csv.
//             </Grid>
//                 <Grid item container spacing={5} direction="row">
//                     <Grid item>
//                         <Button
//                             color="primary"
//                             variant="contained"
//                             type="submit"
//                             className={classes.submitButton}
//                             onClick={onCreateTestSubmit}
//                             disabled={
//                                 isButtonLoading ||
//                                 !patientId ||
//                                 !testId ||
//                                 !patchIdsArray
//                             }
//                         >
//                             Download CSV Template{isButtonLoading && <CircularProgress size={15} className={classes.progess} />}
//                         </Button>
//                     </Grid>
//                     <Grid item>
//                         <Button
//                             color="primary"
//                             variant="contained"
//                             type="submit"
//                             className={classes.submitButton}
//                             onClick={onCreateTestSubmit}
//                             disabled={
//                                 isButtonLoading ||
//                                 !patientId ||
//                                 !testId ||
//                                 !patchIdsArray
//                             }
//                         >
//                             Upload Tests CSV{isButtonLoading && <CircularProgress size={15} className={classes.progess} />}
//                         </Button>
//                     </Grid>

//                 </Grid>

//                 <Grid item>
//                     <Button
//                         color="primary"
//                         variant="contained"
//                         type="submit"
//                         className={classes.submitButton}
//                         onClick={onCreateTestSubmit}
//                         disabled={
//                             isButtonLoading ||
//                             !patientId ||
//                             !testId ||
//                             !patchIdsArray
//                         }
//                     >
//                         Batch Create Test {isButtonLoading && <CircularProgress size={15} className={classes.progess} />}
//                     </Button>
//                 </Grid>
//             </Grid>
//         </>
//     );
// }




import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';


import Papa from 'papaparse'
import { Input } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

function getSteps() {
    return ['Download Template CSV File', 'Create Desired Tests in CSV File', 'Upload CSV File to Create Tests', 'Confirm Test Creation'];
}

function getStepContent(step) {
    switch (step) {
        case 0:
            return `Click the button below to download a CSV template for batch creation of tests. You may edit this file in any CSV editor such as Excel or Notepad++.`;
        case 1:
            return 'The CSV file will be validated prior to test creation. Limited to 10,000 tests per request. No duplicate Test IDs may be present. Ensure field data types are correct.';
        case 2:
            return `Once you have uploaded the CSV and it has beeen validated, click the below button to create the tests.`;
        case 3:
            return `If you are ready to confirm creation of #{tests}, click confirm below.`;
        default:
            return 'Unknown step';
    }
}

export default function CreateBatchTests() {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    function handleDownloadTemplate() {
        console.log("asdf")
    }

    function handleConfirmCreateTests() {

    }

    const [csvFile, setCsvFile] = useState(null);

    function handleCsvChange(event) {
        setCsvFile(event.target.files[0]);
    }

    function importCsv() {
        Papa.parse(csvFile, {
            complete: updateData,
            header: true
        });
    }

    function updateData(result) {
        var data = result.data;
        console.log(data);
    }

    const [rows, setRows] = useState([]);

    useEffect(() => {
        async function getData() {
            const response = await fetch('/data/nodes.csv')
            const reader = response.body.getReader()
            const result = await reader.read() // raw array
            const decoder = new TextDecoder('utf-8')
            const csv = decoder.decode(result.value) // the csv text
            const results = Papa.parse(csv, { header: true }) // object with { data, errors, meta }
            const rows = results.data // array of objects
            setRows(rows)
        }
        getData()
    }, [])


    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            <Typography>{getStepContent(index)}</Typography>
                            <div className={classes.actionsContainer}>
                                <div>
                                    <Button
                                        elevation={1}
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.button}
                                    >
                                        Back
                  </Button>
                                    <Button
                                        elevation={1}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        className={classes.button}
                                    >
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>

                                    {activeStep === 0 && <a href="/files/myfile.pdf" target="_blank" download> <Button
                                        elevation={1}
                                        onClick={handleDownloadTemplate}
                                        className={classes.button}
                                        color="secondary"
                                    >
                                        Download Template
                                    </Button></a>}
                                    {activeStep === 2 && <div>
                                        <Input className="csv-input" type="file" name="file" placeholder={null} onChange={handleCsvChange}/>
                                        
                                        <Button onClick={importCsv}> Validate file</Button></div>}

































                                    {activeStep === 3 && <Button
                                        elevation={1}
                                        onClick={handleConfirmCreateTests}
                                        className={classes.button}
                                        color="secondary"
                                    >
                                        Confirm Test Creation
                                    </Button>
                                    }



                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <Button onClick={handleReset} className={classes.button}>
                        Reset
          </Button>
                </Paper>
            )}
        </div>
    );
}







// class FileReader extends React.Component {
//     constructor() {
//       super();
//       this.state = {
//         csvfile: undefined
//       };
//       this.updateData = this.updateData.bind(this);
//     }

// dsfadsf






    // handleChange = event => {
    //   this.setState({
    //     csvfile: event.target.files[0]
    //   });
    // };

    // importCSV = () => {
    //   const { csvfile } = this.state;
    //   Papa.parse(csvfile, {
    //     complete: this.updateData,
    //     header: true
    //   });
    // };

    // updateData(result) {
    //   var data = result.data;
    //   console.log(data);
    // }

//     render() {
//       console.log(this.state.csvfile);
//       return (
//       );
//     }
//   }

//   export default FileReader;




// import React from 'react'
// import Papa from 'papaparse'

// export default function() {
//   const [rows, setRows] = React.useState([])
//   useEffect(() => {
//     async function getData() {
//       const response = await fetch('/data/nodes.csv')
//       const reader = response.body.getReader()
//       const result = await reader.read() // raw array
//       const decoder = new TextDecoder('utf-8')
//       const csv = decoder.decode(result.value) // the csv text
//       const results = Papa.parse(csv, { header: true }) // object with { data, errors, meta }
//       const rows = results.data // array of objects
//       setRows(rows)
//     }
//     getData()
//   }, [])
//   return (
//     // <div className="app">
//     //   <Table cols={tripColumns} rows={rows} />
//     // </div>
// //   )
// // }
// {/* <form autoComplete="off" noValidate>

// <Grid container spacing={2} direction="row">
//     <Grid item md={6} xs={12} >
//         <form className={classes.container} noValidate>
//             <TextField id="date" label="Planned Test Start Date" type="date" defaultValue="2017-05-24" className={classes.textField} InputLabelProps={{ shrink: true }} />
//         </form>
//         <TextField
//             label="Patient ID"
//             margin="dense"
//             name="patientId"
//             variant="outlined"
//             value={patientId}
//             onChange={onPatientIdChange}
//         />
//     </Grid>
//     <Grid item md={6} xs={12}>
//         <TextField
//             label="Test ID"
//             margin="dense"
//             name="testId"
//             variant="outlined"
//             value={testId}
//             onChange={onTestIdChange}
//         />
//     </Grid>
//     <Grid item md={6} xs={12}>
//         <TextField
//             label="Planned Test Start Date"
//             margin="dense"
//             name="plannedTestStartDate"
//             variant="outlined"
//             value={plannedTestStartDate}
//             onChange={onPlannedTestStartDateChange}
//         />
//     </Grid>
//     <Grid item md={6} xs={12}>
//         <TextField
//             label="Patch IDs Array"
//             margin="dense"
//             name="patchIdsArray"
//             variant="outlined"
//             value={patchIdsArray}
//             onChange={onPatchIdsArrayChange}
//         />
//     </Grid>
// </Grid>
// </form> */}